/**
 * Typy eventów
 * @constant {object}
 */

const EventTypes = {
    TRANSFER: "T",
    INSEMINATION: "I",
    PARTURITION: "P",
    NO_PREGNANCY: "N",
    FALL: "F",
    GRAFTING: "G",
    SEPARATION: "S",
    SELL: "L",
    USG: "U",
    SEPARATION_TO_MOMMY: "M",
    SELECTION: "X",
    MOMMY: "W",
    FALL_PIGLETS: "V",
    CONDITION: "D",
    INSERTION: "IN",
    TREATMENT: "TR",
    WEIGHTING: "WE",
    ACTIVE_NIPPLES: "AN",
    RECLASSIFY: "R",
    PIGLETS_TREATMENT: "PT",
    HEAT: "H",
    SOW_CYCLES: "B",
    CASTRATION: "CA",
    TO_INSEMINATION: "TI",
    TO_REPEAT: "TT",
    PARTURITION_START: "PS",
    PARTURITION_END: "PE",
    PIGLET_RECLASSIFY: "PR",
    PARTURITION_STATE: "ST",
    FIRST_MILK: "FM",
    TATTOO: "TT",
    COMMENTS: "CM",
    TECHNOLOGY_GROUP_TRANSFER: "TGT",
    TAGGING_SUBTRACT: "TS",
    TAGGING_CREATE: "TC",
    RECLASSIFY_SOW: "RS",
    SEPARATION_TO_MOMMY_GILTS: "MG",
    IS_MOMMY: "IM",
    FAT_MEASUREMENT:'P2'
};

module.exports = EventTypes;
